<template>
  <div class="list-item-title" :class="fontMedium ? 'list-item-title--font-medium' : ''">
    <div class="list-item-title__inner" ref="listTitle">
      <slot></slot>
    </div>

    <div class="list-item-title__cut" v-show="showCut"></div>
  </div>
</template>

<script>
import setClassModifiers from '@/mixins/setClassModifiers'

export default {
  mixins: [setClassModifiers],

  props: {
    fontMedium: {
      type: Boolean,
      default: false
    },

    cutToLength: {
      type: [Number, String],
      default: null
    }
  },

  data () {
    return {
      showCut: false
    }
  },

  methods: {
    cutInnerText () {
      if (!this.cutToLength) {
        return
      }

      const textContent = this.$refs.listTitle.innerText
      const targetLength = this.cutToLength - 1

      if (textContent.length > targetLength) {
        this.showCut = textContent.length > targetLength
        this.$refs.listTitle.innerText = `${textContent.substr(0, targetLength)}`
      }
    }
  },

  mounted () {
    // this.cutInnerText()
  },

  updated () {
    // this.cutInnerText()
  }
}
</script>

<style lang="scss">
  .list-item-title {
    font-size: 1.5rem;
    font-weight: 500;
    line-height: 1.4;

    display: inline-block;
    position: relative;

    &__inner {
      display: inline-block;
      position: relative;
    }

    &--font-medium {
      font-weight: 500;
    }

    &__cut {
      position: absolute;
      right: 0;
      top: 0;
      height: 100%;
      width: 2.2rem;
      background: linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 91.25%);
    }
  }

  .list-item__sub {
    @media(hover: hover) and (pointer: fine) {
      &:hover .list-item-title__cut, &:active .list-item-title__cut {
        background: linear-gradient(270deg, $color-space-lighten 0%, rgba($color-space-lighten, 0) 91.25%);
        outline: none;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      }
    }
  }
</style>
